import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule }  from '@angular/forms';

import { ManageUsersComponent } from './manage-users.component';

import { ManageUsersService } from './manage-users.service';
import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule
  ],
  providers: [
    ManageUsersService,
  ],
  declarations: [
    ManageUsersComponent,
  ],
  exports: [
    ManageUsersComponent,
  ]
})
export class ManageUsersModule { }
